export default {
    attributes: {
        containerNumber: {
          type: 'string',
          required: true,
        },
        seal:{
          type:'string',
          required:true
        },
        arrivalnotification: {
          model: 'arrivalnotification',
        },
        vol:{type:'number',
          required:true
        },
        weight:{
          type:'number',
          required:true,
        },
        packagesContainers:{
          type:'number',
          required:true,
        },
      },
  };


// WEBPACK FOOTER //
// ./src/models/Containers.js